import { useEffect } from 'react';

export interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  ogType?: string;
  image?: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function buildAbsoluteUrl(path = ''): string {
  const base = (__BASE_PATH__ || '/').replace(/\/+$/, '');
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${window.location.origin}${base}${clean === '/' ? '' : clean}` || window.location.origin;
}

export function useSeo({ title, description, keywords, path, ogType = 'website', image }: SeoOptions) {
  useEffect(() => {
    const canonical = buildAbsoluteUrl(path);
    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', 'index,follow');
    if (keywords) {
      upsertMeta('name', 'keywords', keywords);
    }
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', ogType);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:site_name', '黑料大赛');
    if (image) {
      upsertMeta('property', 'og:image', image);
    }
    upsertMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    if (image) {
      upsertMeta('name', 'twitter:image', image);
    }

    let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonical;
  }, [title, description, keywords, path, ogType, image]);
}